import { TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import { MarketItem } from '../../../app/services/api/orderManagementClient';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  item: MarketItem;
};

const ProductItemRow: FC<Props> = ({ item }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['ProductUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    // Build query parameters for navigation
    const params = new URLSearchParams();
    params.set('companyId', item.companyId.toString());
    if (item.customerTypeId !== undefined) {
      params.set('customerTypeId', item.customerTypeId.toString());
    }
    
    navigate(`/products/edit/${item.contentId}?${params.toString()}`);
  };

  return (
    <TableRow 
      onClick={canEdit ? handleRowClick : undefined}
      sx={{ 
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        {item.itemNumber}
      </TableCell>
      <TableCell>
        {item.itemName}
      </TableCell>
      <TableCell>
        {item.primaryCategoryName || item.marketPrimaryCategoryName || '-'}
      </TableCell>
      <TableCell>
        {item.primaryUom}
      </TableCell>
      <TableCell>
        {item.orderableUom}
      </TableCell>
      <TableCell>
        {item.packSize || '-'}
      </TableCell>
      <TableCell>
        {item.caseSize || '-'}
      </TableCell>
      <TableCell>
        {item.innerPackSize || '-'}
      </TableCell>
    </TableRow>
  );
};

export default ProductItemRow;
